export * from './pix-info.component'